<template>
  <div class="rooming">
    <p class="p">
      En este paso completa los datos de cada pasajero y asignales un lugar en el micro y la/s
      habitacion/es en cada hotel. Una vez tengas todos tus pasajeros asignados y podras ver
      el subtotal de la reserva, y confirmarla.
    </p>
    <div class="rooming-main">
      <div class="rooming-col-right">
        <div>
          <div
            v-for="passenger in $store.state.modify.passengers"
            :key="passenger.tmp_id"
          >
            <passenger
              :passenger="passenger"
              @sit="assign"
              @locate="locate"
              :editable="editable"
            />
          </div>
        </div>
        <worth />
      </div>
      <div class="rooming-col-left">
        <p class="rooming-timer">
          Asientos bloqueados
          <strong>{{ timer.minutes }}:{{ timer.seconds }}</strong>
        </p>
        <locations ref="locations" />
      </div>
    </div>
    <div class="rooming-footer mb-3">
      <template
        v-if="
          $store.state.modify.budget.total &&
            $store.state.modify.passengers.every(
              pax => pax.type == PASSENGER_TYPES.infoas.str || pax.rooming
            )
        "
      >
        <span>CONFIRMÁ LA ASIGNACIÓN</span>
        <btn
          color="orange"
          size="xs"
          @click="next"
        >
          CONFIRMAR
        </btn>
      </template>
      <btn
        color="outline"
        size="xs"
        @click="cancel"
      >
        CANCELAR
      </btn>
    </div>
  </div>
</template>

<script>
import Passenger from './components/Passenger'
import Locations from './components/Locations'
import Worth from './components/Worth'
import Btn from '@/components/Btn'
import swal from 'sweetalert2'
import { PASSENGERS, ROOMING } from '@/store/mutations'
import { clone, padding0 } from '@/utils'
import { PASSENGER_TYPES } from '@/constans'

const info = title => swal({ type: 'info', title })

export default {
  components: { Btn, Locations, Passenger, Worth },

  computed: {
    timer () {
      return {
        seconds: padding0(Math.floor(this.$store.state.modify.session % 60), 2),
        minutes: padding0(Math.floor((this.$store.state.modify.session / 60) % 60), 2)
      }
    },
    rooming () {
      return this.$store.state.modify.rooming
    },
    passengers () {
      return this.$store.state.modify.passengers
    }
  },
  methods: {
    cancel () {
      this.$router.push({ name: 'reservation_passengers', params: this.$route.params })
      this.$store.dispatch('modify/CLOSE')
    },
    distribute (rooming, passenger_tmp_id) {
      this.$store.commit(
        'modify/' + PASSENGERS,
        clone(this.$store.state.modify.passengers).map(passenger => {
          if (passenger.tmp_id == passenger_tmp_id) {
            passenger.rooming = {
              tmp_id: rooming.tmp_id,
              base: rooming.base,
              rooms: rooming.rooms
            }
          }
          return passenger
        })
      )
      this.$store.commit(
        'modify/' + ROOMING,
        clone(this.$store.state.modify.rooming).map(room => {
          if (room.tmp_id == rooming.tmp_id) {
            room.passengers = room.passengers.concat([passenger_tmp_id])
          }
          return room
        })
      )
      this.$refs.locations.disable = null
      this.$refs.locations.hover = null
      this.editable = true
      this.$store
        .dispatch('modify/BUDGETING')
        .catch(error => swal({ html: error.response.data.msg, type: 'error' }))
    },
    sit (seat, tmp_id) {
      const passengers = this.$store.state.modify.passengers
      if (passengers.some(p => p.seat_id == seat.id)) {
        info('El asiento ya esta ocupado.')
        this.assign(tmp_id)
      } else {
        this.$store.commit(
          'modify/' + PASSENGERS,
          passengers.map(passenger => {
            if (passenger.tmp_id == tmp_id) {
              passenger.seat_id = seat.id
              passenger.seat_categ = seat.categ
              passenger.seat_categ_str = seat.categ_str
            }
            return passenger
          })
        )
        this.$refs.locations.disable = null
        this.editable = true
        this.$refs.locations.hover = null
      }
    },
    locate (tmp_id) {
      this.$refs.locations.$once('distribute', room => this.distribute(room, tmp_id))
      this.$refs.locations.disable = 'buses'
      this.$refs.locations.hover = 'hotels'
      this.editable = false
    },
    assign (tmp_id) {
      this.$refs.locations.$once('sit', seat => this.sit(seat, tmp_id))
      this.$refs.locations.disable = 'hotels'
      this.$refs.locations.hover = 'buses'
      this.editable = false
    },
    next () {
      if (this.passengers.some(p => !!p.main && !!p.ident && !!p.name && !!p.surname)) {
        this.$emit('goto', 'conditions')
      } else {
        info(
          'Debe completar al menos DNI/PASAPORTE, APELLIDO Y NOMBRE del pasajero titular.'
        )
      }
    }
  },

  data () {
    return {
      PASSENGER_TYPES,
      editable: true,
      notes: []
    }
  }
}
</script>
